module.exports = __webpack_public_path__ + "img/Psychology2.bbd299d7.png";